import {NgModule} from '@angular/core';
import {AuthService} from './auth.service';
import {ApiService} from './api.service';
import {StatisticsService} from './statistics.service';
import {UserService} from './user.service';
import {InstitutionService} from './institution.service';
import {AddressService} from './address.service';
import {GroupService} from './group.service';
import {MunicipalityService} from './municipalities.service';
import {EulaService} from './eula.service';
import {BillingService} from './billing.service';
import {TeamService} from './team.service';

@NgModule({
  providers: [
    ApiService,
    AuthService,
    StatisticsService,
    UserService,
    InstitutionService,
    AddressService,
    GroupService,
    MunicipalityService,
    EulaService,
    BillingService,
    TeamService
  ]
})
export class CoreModule {}
